export const campaignOccurrenceTypes = {
  SCHEDULED: 'SCHEDULED',
  ON_EVENT: 'ON_EVENT',
  ON_DEMAND: 'ON_DEMAND',
  INTERNAL_SURVEY_RESPONSE: 'INTERNAL_SURVEY_RESPONSE',
  EXTERNAL_SURVEY_RESPONSE: 'EXTERNAL_SURVEY_RESPONSE'
};

export const campaignBasicOccurrenceTypeOptions = [
  {
    value: campaignOccurrenceTypes.ON_EVENT,
    label: 'Event Driven Campaign'
  }
];

export const campaignStandardOccurrenceTypeOptions = [
  {
    value: campaignOccurrenceTypes.SCHEDULED,
    label: 'Scheduled Campaign'
  },
  ...campaignBasicOccurrenceTypeOptions
];

export const campaignOnDemandOccurrenceTypeOptions = [
  ...campaignStandardOccurrenceTypeOptions,
  {
    value: campaignOccurrenceTypes.ON_DEMAND,
    label: 'On Demand Campaign'
  }
];

export const campaignOccurrenceTypeOptions = [
  ...campaignOnDemandOccurrenceTypeOptions,
  {
    value: campaignOccurrenceTypes.INTERNAL_SURVEY_RESPONSE,
    label: 'Internal Survey Response Campaign'
  },
  {
    value: campaignOccurrenceTypes.EXTERNAL_SURVEY_RESPONSE,
    label: 'External Survey Response Campaign'
  }
];
